import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomePin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 50,
	viewBox: "0 0 512 512",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M256 0C152 0 64 88 64 192c0 138.4 168 320 192 320s192-181.6 192-320C448 88 360 0 256 0z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256 90 L110 280 H160 V360 H230 V270 H282 V360 H352 V280 H402 L256 90 Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgHomePin);
export { ForwardRef as ReactComponent };
